import getAdminTracking from "./getAdminTracking"; 
const adminTracking = {
    getAdminTracking
}
export default adminTracking;